import { Navigate } from 'react-router-dom';

import Roles from '../contants/Roles';
import { StorageService } from '../services';
import AuthService from '../services/AuthService';
import { useEffect, useState } from 'react';

interface IProps {
    roles?: Roles[];
    children: any;
}

const PrivateRouteInterceptor = ({ roles: routeRoles, children }: IProps) => {
    const [permissionChecked, setPermissionChecked] = useState(false);
    const [routeToRedirect, setRouteToRedirect] = useState<string>();

    useEffect(() => {
        const getRoute = async () => {
            const roles = await StorageService.getUserRoles();

            if (roles.length === 1 && roles[0] === Roles.PreUser) {
                setRouteToRedirect('/approval-process');
                setPermissionChecked(true);
                return;
            }

            await hasPermission();
        };

        async function hasPermission() {
            const hasPermission = await AuthService.hasPermission(routeRoles);

            if (!hasPermission) {
                setRouteToRedirect('/403');
            }

            setPermissionChecked(true);
        }

        getRoute();
    }, [routeRoles])

    if (!routeToRedirect) {
        return (children);
    }

    return (<Navigate to={routeToRedirect} />)
};

export default PrivateRouteInterceptor;
